export default "__VITE_ASSET__CklFR35Y__"